export const SET_ADDRESS_START_DATE_YEAR = 'setAddressStartDateYear';
export const SET_ADDRESS_START_DATE_MONTH = 'setAddressStartDateMonth';
export const SET_ADDRESS_END_DATE_YEAR = 'setAddressEndDateYear';
export const SET_ADDRESS_END_DATE_MONTH = 'setAddressEndDateMonth';
export const SET_ADDRESS_ADDRESS = 'setAddressAddress';
export const SET_ADDRESS_TYPE_ID = 'setAddressTypeId';
export const SET_ADDRESS_CLIENT_IDS = 'setAddressClientIds';
export const SET_ADDRESS_OWNERSHIP_TYPE_ID = 'setAddressOwnershipTypeId';
export const SET_ADDRESS_ERROR = 'setAddressError';
